import React from 'react';
import Button from '../../Buttons/Button/Button';
import CardAgreement from '../CardAgreement/CardAgreement';

import classes from './Categories.module.scss';

const Categories = ({ categories, categorySelected, setCategorySelected, nextHandler }) => {
  const selectCategory = category => {
    setCategorySelected(category);
  };
  return (
    <>
      <span className='bold-20'>Agregar nuevo convenio</span>
      <span className={`${classes.text} semibold-18`}>Primero selecciona una categoría</span>
      <div className={classes.table}>
        {categories.map((category, idx) => (
          <CardAgreement key={idx} onClick={selectCategory} categorySelected={categorySelected} category={category} />
        ))}
      </div>
      <div className={classes.down}>
        <Button enabled={!!categorySelected} onClick={nextHandler}>
          Continuar
        </Button>
      </div>
    </>
  );
};

export default Categories;
